<template>
<main class="bodyMain2">
<main class="main-box-master">
  <div class='rel-main-box'>
  <div class='rlc-cont1 back-h3 fono'>
  <div class="flx-mn">
  <div class="catsercont">
    <ul>
      <li class="">Postup nahrání zakázky</li>
        <div class="flx-mn1">
            <p>Nahrajte CSV soubor <a class="href" href="http://floss.pneuprezuti.cz/upload_csv.zip">zde</a> a vyčkejte. Nahrání trvá přibližně minutu. Aby se vám stav nahrání zobrazil, proveďte refresh web stránky v prohlížeči klinutím na &nbsp;
            </p>
            <img class="img3" :src="require('@/assets/btn-hledat.png')" />
        </div>
      <li class="li_tra">Popis jednotlivých stavů zakázky</li>
        <div class="img_algn">
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/probiha.png')" />
                <p>Takto barevně označený řádek znamená, že se prování požadovaná akce a do ukončení nelze se zakázkou nijak manipulovat. Žádná akce by neměla trvat déle než 1min.</p>
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-uspesne-dokonceno.png')" />
                <p>Zakázka byla úspěšně uložena a zpracována v MyWay. Zakázku již nelze změnit bez zásahu 4Fleet back office. Stejnou zakázku již znovu nenahrávejte. Pokud jí potřebujete přesto změnit, kontaktujte 4Fleet back office.</p>
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-zakazka_neulozena.png')" />
                <p>Zakázka nebyla vůbec nahrána do MyWay z důvodu nějaké chyby. Opravte a zakázku pošlete ještě jednou.</p>
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-smazat_zakazku.png')" />
                <p>Zakázka byla v MyWay uložena, ale je nedokončena z důvodu nějaké chyby. Zakázku musíte z MyWay nejdříve smazat viz. tlačítko smazat zakázku a vaší opravenou zakázku nahrát ještě jednou. Pokud se domníváte že je vaše zakázka správně, nic nemažte a kontaktujte 4Fleet back office, který zakázku opraví.</p>
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-uspesne_schvaleno.png')" />
                <p>Zakázka byla úspěšně uložena a automaticky schválena v MyWay. Zakázku lze ještě zrušit nebo ji musíte dokončit.</p><p>Pro zrušení schválení a smazání zakázky v MyWay klikněte na &nbsp;</p>
                <img class="img2" :src="require('@/assets/v2a.png')" />
                <p>Pro dokončení pak na &nbsp;</p>
                <img class="img3" :src="require('@/assets/btn-dokoncit.png')" />
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-schvaleno_s_vyhradou.png')" />
                <p>Jako předchozí status, zakázka je uložena a schválena, ale navíc je vyžadován podpis formuláře AYVENS řidičem. Pokud si nenecháte formulář podepsat, flotila zakázku neuhradí viz. pravidla <a class="href" :href="require('@/assets/ald_form.png')">zde</a>. Smazání nebo uzavžení zakázky je stejné jako předchozí bod. Formulář musíte ale otevžít z MyWay.</p>                        
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/btn-doplnit_schvaleni.png')" />
                <p>Pokud se zobrazí toto pole, lze do uložené zakázky v MyWay ještě doplnit schvalovací číslo, které je dle flotily pro danou zakázku povinné. Pokud jsou požadované přílohy jako foto atd. zadejte tyto přímo do rozpracované zakázky v MyWay.</p>
            </div>
            <div class="flx-mn1">
                <img class="img1" :src="require('@/assets/cekame_schvaleni.png')" />
                <p>Probíhá schvalování zakázky.</p><p>Zhruba po 3min. se zobrazí tlačítko pro &nbsp;&nbsp;</p>
                <img class="img1" :src="require('@/assets/overit_schvaleni.png')" />
                <p>Kliknutím se spustí kontrola schválení a zakázka se uzavře, případně se vypíše důvod zamítnutí.&nbsp;</p>
            </div>                
        </div>
      <li class="li_tra">Další důležité funkce</li>
        <div class="img_algn">
            <div class="flx-mn1">
                <img class="img5" :src="require('@/assets/filtr.png')" />
                <p>Filtrování a vyhledávání v zakázkách podle kategorie nebo RZ, flotily, čísla zakázky atd.</p>
            </div>
            <div class="flx-mn1">
                <img class="img5" :src="require('@/assets/category_search.png')" />
                <p>Kategorii pneumatiky vozidla můžete ověřit přímo z aplikace zadáním RZ a výběrem flotily. </p>
            </div>
            <div class="flx-mn1">
                <img class="img3" :src="require('@/assets/btn-archivovat.png')" />
                <p>Pro lepší přehled doporučujeme dokončené zakázky přesunout z hlavního přehledu do archivu. Tato funkce je dostupná jen pro dokončené zakázky.</p>
            </div>   
            <div class="flx-mn1">
                <img class="img3" :src="require('@/assets/btn-red_green.png')" />
                <p>Semafor, kde zelená je OK a červená špatně. Pokud např. ve sloupci shoda ceny svítí červená, cena vaší zakázky je jiná než cena v MyWay atd.</p></div>                 
            <div class="flx-mn1">
                <img class="img4" :src="require('@/assets/v2e.png')" />
                <p>Screenshot zakázky z MyWay nebo ze schvalovacích portálů jako ITA, GT Net, ŠkoFIN.</p>
            </div>
        </div>
    </ul>   
    </div>
    </div>
    </div>
    </div>
</main>
</main>
</template>

<style>
    body {
        font-family: 'Montserrat', sans-serif;
        margin: 0;
        padding: 0;
        background-color: #1e1e1e;
        color: #fff;
        font-size: 13px;
    }
    .cont-pg { padding: 20px; }
    li {
        font-weight: 700;
        font-size: 14px;
    }        
    .li_tra{ margin-top: 30px; margin-bottom: 20px; }
    .img_algn{
        display: flex;
        flex-direction: column;
        margin-top: 8px;
    }
    .img_algn p { margin-left: 8px; }
    .img1{ width: 120px; }
    .img2{ width: 24px; }
    .img3{ width: 80px; }
    .img4{
        width: 28px;
        margin-right: 26px;
        margin-left: 25px;
    }
    .img5{
        width: 360px;
        margin-right: 26px;
    }        
    .flx-mn1{
        display: flex;
        margin-bottom: 8px;
        align-items: center;
    }
    .flx-mn1 p {margin-left: 15px; }
    a:link    {color: rgb(54, 119, 184); }
    a:visited {color: rgb(41, 146, 88); }
    a:hover   {color: rgb(54, 119, 184); }

</style>